import styled from '@emotion/styled'

export const CustomCard = styled.div({
    background: 'white',
    borderRadius: '21px',
    width: '95%',
    marginLeft: 'auto',
    marginRight: 'auto',
})

export const ContentPadding = styled.div({
    padding: '28px 46px'
})